if (!customElements.get('product-description-toggle')) {
  customElements.define(
    'product-description-toggle',
    class ProductDescriptionToggle extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.product__description-content');
        this.button = this.querySelector('.product__description-toggle');
        if (!this.content || !this.button) return;

        this.update = this.update.bind(this);
        this.button.addEventListener('click', () => {
          const expanded = this.classList.toggle('is-expanded');
          this.button.setAttribute('aria-expanded', expanded.toString());
          this.button.querySelector('span:first-child').textContent = expanded
            ? this.dataset.showLess
            : this.dataset.showMore;
        });

        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this);
        requestAnimationFrame(this.update);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      update() {
        if (this.classList.contains('is-expanded')) return;

        const styles = getComputedStyle(this.content);
        const lineHeight = parseFloat(styles.lineHeight) || parseFloat(styles.fontSize) * 1.5;
        const needsToggle = this.content.scrollHeight > lineHeight * 5 + 2;
        this.classList.toggle('is-collapsible', needsToggle);
        this.button.hidden = !needsToggle;
      }
    }
  );
}
